// extracted by mini-css-extract-plugin
export default {"notes":"Notes_notes__7q8rj","note":"Notes_note__55CSK"};